import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { I18nProvider } from './i18n/i18n.tsx';
import './styles/fonts.css';
import './styles/tokens.css';
import './styles/base.css';
import './styles/components.css';

const container = document.getElementById('root');
if (!container) throw new Error('#root element not found in index.html');

// MVP-272: one `I18nProvider` above everything, including the Stage/guest routes `App` renders
// with no shared shell of their own (App.tsx's own comments on why those two mount before any
// auth branch) — every surface converges on the same `locale`/`t` as its own phase wires it up.
createRoot(container).render(
  <StrictMode>
    <I18nProvider>
      <App />
    </I18nProvider>
  </StrictMode>
);
